// File: frontend/src/contexts/GDPRConsentContext.js

import React, { createContext, useContext, useState, useEffect } from 'react';

const GDPRConsentContext = createContext();

export const useGDPRConsent = () => {
  return useContext(GDPRConsentContext);
};

export const GDPRConsentProvider = ({ children }) => {
  const [hasConsent, setHasConsent] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if consent exists in localStorage
    const storedConsent = localStorage.getItem('gdpr_consent');
    if (storedConsent === 'accepted') {
      setHasConsent(true);
    }
    setIsLoading(false);
  }, []);

  const acceptConsent = () => {
    localStorage.setItem('gdpr_consent', 'accepted');
    setHasConsent(true);
  };

  const rejectConsent = () => {
    // Simply redirect to Google when user declines
    window.location.href = 'https://www.google.com';
  };

  return (
    <GDPRConsentContext.Provider
      value={{
        hasConsent,
        isLoading,
        acceptConsent,
        rejectConsent
      }}
    >
      {children}
    </GDPRConsentContext.Provider>
  );
};

export default GDPRConsentProvider;